<template>
    <tbody>

        <tr v-for="item in inscriptions" :key="item.id">
            <td v-if="mode == 'admin'">
                <router-link :to="{ name: 'EditInscriptionAdmin', params: { id_inscription: item.id } }">
                    <v-btn size="small" variant="text" color="primary-dark" icon="mdi-pencil">
                        <v-icon name="mdi-pencil"></v-icon>
                        <span>Editer</span>
                    </v-btn>
                </router-link>
                <!--   <a :href="base_url + 'billet/get.php?id_inscrit=' + item.id" target="_blank"><v-btn size="small"
                        variant="text" color="primary-dark"><v-icon class="mr-1">mdi-download</v-icon>
                        Billet</v-btn></a> -->
            </td>
            <td v-if="is_lce_performance">{{ item?.champs?.lce26_rank || '-' }}</td>

            <td>{{ item.dossard == '0' ? '-' : item.dossard }}</td>
            <!-- Nom et prénom -->
            <td>
                <div class="d-flex sm-gap">
                    <img class="flag_img" v-if="item.champs?.pays && item.champs.pays != ''"
                        :src="'https://sportips.fr/Flags/' + item.champs?.pays + '.jpg'" :alt="item.champs?.pays" />

                    <div>
                        {{ item.nom.toUpperCase() }} {{ item.prenom.charAt(0).toUpperCase() + item.prenom.slice(1) }}
                        <span v-if="item.champs?.equipe_name && item.champs?.equipe_name != ''"><br />- Equipe {{
                            item.champs?.equipe_name }}</span>
                        <span>{{ enfants_ndr24(item) }}</span>
                        <span v-if="item.champs?.nom_equipe && item.champs?.nom_equipe != ''">{{ item.champs?.nom_equipe
                            }}</span>
                    </div>
                    <div v-if="mode == 'admin'">
                        <v-chip v-if="extra_status(item)" size="small" density="compact" :color="get_status_color(item)"
                            variant="elevated" elevation="0">{{ extra_status(item) }}</v-chip>

                    </div>
                </div>
            </td>
            <!-- Indices de performances -->
            <td v-if="!is_lce_performance">
                <v-chip v-if="showBetrail(item)" color="darkblue" variant="tonal" density="compact"
                    class="px-1 d-flex sm-gap align-center">
                    <img :src="require(`@/assets/img/betrail_logo.png`)" class="chip_logo" />
                    <span class="font-weight-bold">{{ item.betrail / 100 }}</span>
                </v-chip>
                <v-chip v-else-if="showItra(item)" color="black" variant="tonal" density="compact"
                    class="px-1 d-flex sm-gap align-center">
                    <img :src="require(`@/assets/img/logo_itra.png`)" class="chip_logo" />
                    <span class="font-weight-bold">{{ item.cotation_itra }}</span>
                </v-chip>
                <v-chip v-else-if="item.cotation_sportips != '-' && item.cotation_itra == '-'" color="orange-darken-4"
                    variant="tonal" density="compact" class="px-1 d-flex sm-gap align-center"><img
                        :src="require(`@/assets/img/logo_sportips_black.png`)" class="chip_logo" /> <span
                        class="font-weight-bold text-dark">{{ parseInt(item.cotation_sportips) }}</span>
                </v-chip>
                <span v-else>-</span>

            </td>

            <td>{{ get_sexe(item.sexe) }}</td>
            <td v-if="!hide_club">{{ item.club }}</td>
            <!-- Parcours -->
            <td v-if="!is_lce_performance">
                {{ get_parcours(item) }} <span
                    v-if="item.champs?.nom_entreprise_ENR24 && item.champs?.nom_entreprise_ENR24 != ''">(Entreprise {{
                        item.champs?.nom_entreprise_ENR24 }})</span>
            </td>
            <td v-if="mode == 'admin'">{{ get_vague(item) }}</td>
            <td v-if="display_categorie_coureur && !mainStore.billetterie_mode">

                <span v-if="affiche_categorie_ffa(item.id_course)">{{ $coureurCategories.get_ffa(item.date_naissance,
                    mainStore.module) }}</span>
                <span v-if="affiche_categorie_ffr(item.id_course)">{{ $coureurCategories.get_ffr(item.date_naissance,
                    mainStore.module) }}</span>

            </td>
            <!-- Document justificatif -->
            <td v-if="!is_lce_performance">
                <div v-if="allow_upload_pps(item)">
                    <ImportPPS :item="item" @onValidPPS="$emit('onValidPPS')" />

                </div>
                <div v-else>
                    {{ get_statut_documents(item) }}
                </div>

            </td>
            <!-- Validé -->
            <td v-if="!is_lce_performance">
                <div v-if="item.supprime == 1"><v-icon color="dark-red">mdi-close</v-icon></div>
                <div v-else><v-icon v-if="item.valide == 1" color="dark-green">mdi-check</v-icon> <v-icon v-else
                        color="dark-red">mdi-close</v-icon></div>
            </td>


            <td v-if="is_lce_performance">{{ item?.champs?.lce26_performance || 0 }}km</td>

            <td v-if="is_lce_performance">
                <SportipsButton v-if="item?.champs?.lce26_diplome_url && item?.champs?.lce26_performance > 0"
                    class="pa-1" icon="mdi-certificate" :href="item?.champs?.lce26_diplome_url" target="_blank">Mon
                    diplôme</SportipsButton>
            </td>
        </tr>
    </tbody>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import ImportPPS from "@/components/ListInscriptions/ImportPPS.vue";
export default {
    components: { ImportPPS },
    name: 'InscriptionTbody',
    props: ['inscriptions', 'mode', 'display_categorie_coureur', 'courses_by_id'],
    data() {
        return {
            dialogPPS: false,
            numeroPPS: '',
            currentInscriptionId: null,
            base_url: process.env.VUE_APP_API_BASE,
            // Define your component data here
        };
    },
    methods: {
        showBetrail(item) {
            const base = this.mainStore.module.base;
            const isMaxirace = base.includes('MAXIRACE');
            if (item.betrail && item.betrail > 0 && isMaxirace) {
                return true;
            }
            return false;
        },
        showItra(item) {
            const cotation = item.cotation_itra;
            if (!cotation) {
                return false;
            }
            if (cotation == '-') {
                return false;
            }
            if (parseInt(cotation) == 0) {
                return false;
            }
            return true;
        },
        get_status_color(item) {
            if (item.transfere == 1 || item.supprime == 1 || item?.bourse_dossards_status == 'PAID') {
                return "red-darken-4";
            }
            else if ((item?.pending_payment_status && item.pending_payment_status == "PENDING") || (item?.bourse_dossards_status && item.bourse_dossards_status == "PENDING")) {
                return "primary-dark";
            }
            return "green-darken-4";
        },
        extra_status(item) {
            if (item?.pending_payment_status && item.pending_payment_status == "PENDING") {
                return "En attente d'encaissement";
            }

            if (item.transfere == 1) {
                return "Transferée";
            }
            if (item?.bourse_dossards_status && item.bourse_dossards_status == "PENDING") {
                return "En vente";
            }
            if (item?.bourse_dossards_status == "PAID") {
                return "Vendue"
            }
            if (item.from_transfert == 1) {
                return "Provient d'un transfert";
            }
            if (item.supprime == 1) {
                return "Supprimée";
            }
            if (item.from_bourse_dossards == 1) {
                return "Achetée sur la bourse";
            }
            if (item.affiche == 0) {
                return "Non affichée au public";
            }

            return null;
        },
        display_preinscription_status(item) {

            if (!item.pending_payment_status) return false;
            if (item.pending_payment_status != "PENDING") {
                return false;
            }
            return true;
        },

        get_sexe(sexe) {
            if (sexe == "M") {
                return "M";
            } else if (sexe == "F") {
                return "F";
            }
            return "-";
        },
        enfants_ndr24(item) {

            if (item.id_module != 148) {
                return "";
            }
            if (item.champs.nom_enfant_1 == undefined) {
                return "";
            }
            let enfants = "(";
            let enfant_1 = item.champs.nom_enfant_1.toUpperCase() + " " + item.champs.prenom_enfant_1.charAt(0).toUpperCase() + item.champs.prenom_enfant_1.slice(1);
            let enfant_2 = item.champs.nom_enfant_2.toUpperCase() + " " + item.champs.prenom_enfant_2.charAt(0).toUpperCase() + item.champs.prenom_enfant_2.slice(1);
            if (enfant_1.length > 2 || enfant_2.length > 2) {
                enfants = " (Enfants : ";
                if (enfant_1.length > 2) {
                    enfants += enfant_1;
                }
                if (enfant_2.length > 2) {
                    if (enfant_1.length > 2) {
                        enfants += " / " + enfant_2;
                    } else {

                        enfants += enfant_2;
                    }
                }
                enfants += ")";
            }
            return enfants.length > 4 ? enfants : "";
        },
        get_parcours(item) {
            if (!this.courses_by_id) return "";
            let response = "";

            let course = this.courses_by_id[item.id_course] ? this.courses_by_id[item.id_course].nom : " - ";
            let vague = item.vague && this.mode != 'admin' ? " (Vague " + item.vague + ")" : "";
            let sas = this.get_sas(item);
            //let sas = item.champs.sas_preferentiel_10km && item.champs.sas_preferentiel_10km != "NON" ? " (" + item.champs.sas_preferentiel_10km + ")" : "";
            response = course + vague + sas;
            return response;
        },
        get_vague(item) {
            return item.vague ? " Vague " + item.vague : "-";
        },
        get_sas(item) {
            let sas = "";
            let sasPropertyRegex = /^sas_preferentiel_/;
            let sasProperties = Object.keys(item.champs || {}).filter((property) => sasPropertyRegex.test(property));
            if (sasProperties.length > 0) {
                if (item.champs?.[sasProperties[0]] != "NON") {
                    if (item.champs?.[sasProperties[0]] == "OUI") {
                        sas = " (SAS préférentiel)";
                    } else {
                        sas = " (" + item.champs?.[sasProperties[0]] + ")";
                    }
                }
            }
            return sas;
        },

        affiche_categorie_ffa(id) {
            if (this.is_lce_performance) return true;
            if (!this.courses_by_id) return false;
            if (id == 0) return false;
            let selected_course = this.courses_by_id[id];
            for (let i = 0; i < selected_course.metadatas.length; i++) {
                if (selected_course.metadatas[i].nom == "est_chronometre" && selected_course.metadatas[i].valeur == "0") {
                    return false;
                }
                if (selected_course.metadatas[i].nom == "discipline" && selected_course.metadatas[i].valeur != "Course à pied" && selected_course.metadatas[i].valeur != "Marche nordique") {
                    return false;
                }
            }
            return true;
        },
        affiche_categorie_ffr(id) {
            if (!this.courses_by_id) return false;
            if (id == 0) return false;
            let selected_course = this.courses_by_id[id];
            if (!selected_course) return false;
            if (!selected_course.metadatas) return false;
            for (let i = 0; i < selected_course.metadatas.length; i++) {
                if (selected_course.metadatas[i].nom == "est_chronometre" && selected_course.metadatas[i].valeur == "0") {
                    return false;
                }
                if (selected_course.metadatas[i].nom == "discipline" && selected_course.metadatas[i].valeur != "Longe côte") {
                    return false;
                }
            }
            return true;
        },

        get_statut_paiement(item) {
            if (item == 1) {
                return "OK";
            } else {
                return "Non payé";
            }
        },
        get_statut_documents(item) {
            if (item.document_valide == 1) return "Validé";
            if (item.document_recu == 1) return "Reçu";
            if (item.document_recu == 0) return "Non reçu";
            return "Non reçu/En attente de validation";
        },

        allow_upload_pps(item) {
            //ANNEE NAISSANCE si mineur pas affiché
            const date_fin_evenement = this.mainStore.module.evenement.date_fin;
            const dateNaissance = this.$moment(item.date_naissance);
            const age = this.$moment(date_fin_evenement).diff(dateNaissance, 'years');
            if (age < 18) {
                return false;
            }
            if (item.document_recu == '1' || item.document_valide == '1') return false;
            if (this.$moment(date_fin_evenement).diff(this.$moment(), "months") >= 3) {
                return false;
            }
            if (this.mainStore.module.status == "apres_fermeture" && !this.mainStore.module.has_accueil_qr_code) {
                return false;
            }
            return this.mainStore.module.has_pps;
        },

        // Define your component methods here
    },
    computed: {
        ...mapStores(useMainStore),
        is_lce_performance() {
            return this.mode == 'lce_performance';
        },
        hide_club() {
            return this.mainStore.module.base == 'MAM26';
        }

        // Define your computed properties here
    },
    mounted() {


        // Lifecycle hook when the component is mounted
    }
};
</script>

<style scoped>
/* Your component styles go here */
td {
    white-space: nowrap;
    font-size: 12px !important;
}

.chip_logo {
    width: auto;
    height: 10px;
}

.chip_cote_text {
    margin-top: 2px;
    font-size: 1.1rem;
    margin-left: 5px;
    font-weight: bold;
}

.chip_cotation {
    height: 20px;
}
</style>